import NestedForm from "@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js"

export default class extends NestedForm {
  add (event) {
    super.add(event)

    const allItems = this.element.querySelectorAll(".nested-form-wrapper")
    const currentItemElement = allItems[allItems.length - 1]

    if (currentItemElement !== undefined) {
      const positionInput = currentItemElement.querySelector("input[name*='position']")
      if (positionInput) {
        positionInput.value = allItems.length
      }
    }
  }
}
